import { defineEvent } from "@visioni/a3s-analytics";
import type { TestSignalPath } from "@visioni/a3s-monitoring/app";
import type { CameraScope } from "@src/features/cameras/analytics";
import type { RequestErrorType } from "@src/services/api/error-type";

// `CameraTestSignals`, shared by web and native. Support users only.

/**
 * The trigger command was accepted for delivery to the camera. Not that a signal
 * arrived: the page's watch reports that.
 */
export const AlarmTestSignalSent = defineEvent<CameraScope & { signal_path: TestSignalPath }>("Alarm Test Signal Sent");
export const AlarmTestSignalFailed = defineEvent<
  CameraScope & { signal_path: TestSignalPath; error_type: RequestErrorType }
>("Alarm Test Signal Failed");
